module.exports = __webpack_public_path__ + "img/best_mb.91300aed.png";